'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:AssignmentsShowCtrl
 * @description
 * # AssignmentsShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('AssignmentsShowCtrl', [
    '$scope', '$stateParams', 'Assignment', 'toaster',
    function ($scope, $stateParams, Assignment, toaster) {
      $scope.assignment = {};

      function parseYmd(s){
        if (!s) return null;
        if (angular.isDate(s)) return s;
        if (!angular.isString(s)) return null;
        var m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!m) { try { return new Date(s); } catch(e){ return null; } }
        return new Date(parseInt(m[1],10), parseInt(m[2],10)-1, parseInt(m[3],10));
      }
      function computeDurationDays(start, end){
        if (!start || !end) return null;
        var ms = (end.getTime() - start.getTime());
        return Math.floor(ms / (1000*60*60*24)) + 1;
      }

      var id = $stateParams.assignmentId || $stateParams.id;
      if (id) {
        Assignment.find(id).then(function(resp){
          $scope.assignment = (resp.data && (resp.data.assignment || resp.data)) || {};
          var s = parseYmd($scope.assignment.start_on);
          var e = parseYmd($scope.assignment.end_on);
          $scope.assignment.duration_days = computeDurationDays(s, e);
        }).catch(function(){
          toaster.pop('error', 'Asignación', 'No se pudo cargar la asignación');
        });
      } else {
        toaster.pop('error', 'Asignación', 'ID de asignación no especificado');
      }
    }
  ]);
